import { useState } from "react";
import { server } from "../../config";
import ProductSmallTile from "../product-tile/product-small-tile";
export default function FrontProducts() {
	const [randomProducts, setRandomProducts] = useState<any[] | null>(null);
	const [morocanoil, setMorocanoil] = useState<any[] | null>(null);
	const [kerastase, setKerastase] = useState<any[] | null>(null);
	const [beardProducts, setBeardProducts] = useState<any[] | null>(null);
	const [fetchedRandomProducts, setFetchedRandomProducts] = useState(false);

	if (!fetchedRandomProducts) {
		setFetchedRandomProducts(true);
		var funcs$ = [
			fetch(`${server}/api/category/getRandom?category=serum`),
			fetch(`${server}/api/category/getRandom?category=shampoo`),
			fetch(`${server}/api/getFrontProducts`),
		]
		Promise.all(funcs$).then(async (response) => {
			setFetchedRandomProducts(true);
			let randomProducts = await response[1].json();
			let randomProducts2 = await response[0].json();
			randomProducts = randomProducts.concat(randomProducts2);
			let frontProducts = await response[2].json();
			setMorocanoil(shuffleArray(frontProducts.filter((p: any) => p.brand === 'Moroccanoil')));
			setKerastase(shuffleArray(frontProducts.filter((p: any) => p.brand === 'Kérastase')));
			setBeardProducts(shuffleArray(frontProducts.filter((p: any) => p.catalogName.indexOf("Mann") > -1)));
			setRandomProducts(shuffleArray(randomProducts));
		}).catch((error) => {
			console.error(error);
			setFetchedRandomProducts(true);
		});
	}


	function shuffleArray(array: any[]) {
		for (var i = array.length - 1; i >= 0; i--) {
			var j = Math.floor(Math.random() * (i + 1));
			var temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
		return array;
	}
	return (
		<>
			<div className="hideInMobile hideOnPad">

			</div>
			<div className="showInMobile">

			</div>
			<h2>Kérastase</h2>
			<section>
				{
					kerastase?.map && kerastase?.map(p =>
						<ProductSmallTile detailsPath={`/produkter/${p.brand}`} product={p} size='normal' key={p._id} />
					)
				}
			</section>
			<h2>Skjeggpleie</h2>
			<section>
				{
					beardProducts?.map && beardProducts?.map(p =>
						<ProductSmallTile detailsPath={`/produkter/${p.brand}`} product={p} size='normal' key={p._id} />
					)
				}
			</section>
			<h2>Utvalgte produkter</h2>
			<section>
				{
					randomProducts?.map && randomProducts?.map(p =>
						<ProductSmallTile detailsPath={`/produkter/${p.brand}`} product={p} size='normal' key={p._id} />
					)
				}
			</section>
			<div className="hideInMobile hideOnPad">
				
			</div>
		</>
	);
}